import React from 'react';

class LoadingIndicator extends React.Component {


	render() {
		return (<div className="loading-indicator-container">
			<div className="loading-indicator">
				<span>Loading, please wait...</span>
				<div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
			</div>
		</div>);
	}
}



export default LoadingIndicator;  


// WEBPACK FOOTER //
// ./src/components/Layout/LoadingIndicator.js